/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardAvailableBalanceData model module.
 * @module model/DashboardAvailableBalanceData
 * @version 1.0
 */
class DashboardAvailableBalanceData {
    /**
     * Constructs a new <code>DashboardAvailableBalanceData</code>.
     * @alias module:model/DashboardAvailableBalanceData
     */
    constructor() { 
        
        DashboardAvailableBalanceData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardAvailableBalanceData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardAvailableBalanceData} obj Optional instance to populate.
     * @return {module:model/DashboardAvailableBalanceData} The populated <code>DashboardAvailableBalanceData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardAvailableBalanceData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('targetHour')) {
                obj['targetHour'] = ApiClient.convertToType(data['targetHour'], 'Number');
            }
            if (data.hasOwnProperty('availableBalanceHvh')) {
                obj['availableBalanceHvh'] = ApiClient.convertToType(data['availableBalanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('availableBalancePer')) {
                obj['availableBalancePer'] = ApiClient.convertToType(data['availableBalancePer'], 'Number');
            }
            if (data.hasOwnProperty('availableBalanceXper')) {
                obj['availableBalanceXper'] = ApiClient.convertToType(data['availableBalanceXper'], 'Number');
            }
            if (data.hasOwnProperty('availableBalanceUsdt')) {
                obj['availableBalanceUsdt'] = ApiClient.convertToType(data['availableBalanceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('availableBalanceArb')) {
                obj['availableBalanceArb'] = ApiClient.convertToType(data['availableBalanceArb'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalanceHvh')) {
                obj['coldWalletBalanceHvh'] = ApiClient.convertToType(data['coldWalletBalanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalancePer')) {
                obj['coldWalletBalancePer'] = ApiClient.convertToType(data['coldWalletBalancePer'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalanceXper')) {
                obj['coldWalletBalanceXper'] = ApiClient.convertToType(data['coldWalletBalanceXper'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalanceUsdt')) {
                obj['coldWalletBalanceUsdt'] = ApiClient.convertToType(data['coldWalletBalanceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalanceArb')) {
                obj['coldWalletBalanceArb'] = ApiClient.convertToType(data['coldWalletBalanceArb'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardAvailableBalanceData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardAvailableBalanceData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
DashboardAvailableBalanceData.prototype['targetDate'] = undefined;

/**
 * @member {Number} targetHour
 */
DashboardAvailableBalanceData.prototype['targetHour'] = undefined;

/**
 * @member {Number} availableBalanceHvh
 */
DashboardAvailableBalanceData.prototype['availableBalanceHvh'] = undefined;

/**
 * @member {Number} availableBalancePer
 */
DashboardAvailableBalanceData.prototype['availableBalancePer'] = undefined;

/**
 * @member {Number} availableBalanceXper
 */
DashboardAvailableBalanceData.prototype['availableBalanceXper'] = undefined;

/**
 * @member {Number} availableBalanceUsdt
 */
DashboardAvailableBalanceData.prototype['availableBalanceUsdt'] = undefined;

/**
 * @member {Number} availableBalanceArb
 */
DashboardAvailableBalanceData.prototype['availableBalanceArb'] = undefined;

/**
 * @member {Number} coldWalletBalanceHvh
 */
DashboardAvailableBalanceData.prototype['coldWalletBalanceHvh'] = undefined;

/**
 * @member {Number} coldWalletBalancePer
 */
DashboardAvailableBalanceData.prototype['coldWalletBalancePer'] = undefined;

/**
 * @member {Number} coldWalletBalanceXper
 */
DashboardAvailableBalanceData.prototype['coldWalletBalanceXper'] = undefined;

/**
 * @member {Number} coldWalletBalanceUsdt
 */
DashboardAvailableBalanceData.prototype['coldWalletBalanceUsdt'] = undefined;

/**
 * @member {Number} coldWalletBalanceArb
 */
DashboardAvailableBalanceData.prototype['coldWalletBalanceArb'] = undefined;






export default DashboardAvailableBalanceData;

